import { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LoginScreen } from '@adiox/ui';
import { useSession, useSessionContext } from '@adiox/ui';
import { Wordmark } from '@adiox/ui';
import { Workspace } from './shell/Workspace';

function Splash() {
  return (
    <main className="grid h-full place-items-center bg-bg" aria-busy="true" aria-label="Loading">
      <Wordmark className="h-10 animate-pulse" />
    </main>
  );
}

/** Chooses what to show from the session state: splash, sign in, "session ended" or the workspace. */
export function App() {
  const { tokens } = useSessionContext();
  const session = useSession();
  const [queryClient] = useState(
    () => new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 5_000 } } }),
  );

  useEffect(() => {
    void tokens.restore(); // a refresh cookie from an earlier visit signs the user straight back in
  }, [tokens]);

  useEffect(() => {
    if (session.status !== 'authenticated') {
      queryClient.clear(); // never keep one user's data around after the session ends
    }
  }, [session.status, queryClient]);

  switch (session.status) {
    case 'unknown':
      return <Splash />;
    case 'authenticated':
      return (
        <QueryClientProvider client={queryClient}>
          <Workspace />
        </QueryClientProvider>
      );
    case 'expired':
      return (
        <LoginScreen
          identifier="account"
          notice="Your session has ended. Sign in again to continue; your layout is kept."
        />
      );
    default:
      return <LoginScreen identifier="account" />;
  }
}
